export enum TaxBandEnum {
	UNEMPLOYED = 1,
	NO_INCOME_TAX = 2,
	BASIC = 3,
	HIGHER = 4,
	ADDITIONAL = 5
}
